import { createGlobalStyle } from 'styled-components';
import { resetCss } from './resetCss';
import {
  BREAKPOINTS,
  FONT_SIZE,
  FONT_WEIGHT,
  LAYOUT,
  media,
} from './themes/constants';
import {
  lightThemeVariables,
  commonThemeVariables,
  darkThemeVariables,
  cnhThemeVariables,
  antOverrideCssVariables,
} from './themes/themeVariables';
import { cnhComponentStyles } from './themes/cnh/cnhComponentStyles';

export default createGlobalStyle`

  ${resetCss}

  [data-theme='light'],
  :root {
    ${lightThemeVariables}
  }

  [data-theme='dark'] {
    ${darkThemeVariables}
  }

  [data-theme='cnh'] {
    ${cnhThemeVariables}
    ${cnhComponentStyles}
  }

  :root {
    ${commonThemeVariables};
    ${antOverrideCssVariables};
  } 

  [data-no-transition] * {
    transition: none !important;
  }
  
  .range-picker {
    & .ant-picker-panels {
      @media only screen and ${media.xs} and (max-width: ${
  BREAKPOINTS.md - 0.02
}px) {
        display: flex;
      flex-direction: column;
      }
    }
  }

  .search-dropdown {
    box-shadow: var(--box-shadow);

    @media only screen and ${media.xs} and (max-width: ${
  BREAKPOINTS.md - 0.02
}px)  {
      width: calc(100vw - 16px);
    max-width: 600px;
    }

    @media only screen and ${media.md} {
      max-width: 323px;
    }
  }

.language-dropdown.ant-dropdown {
  min-width: 240px !important;
  width: auto !important;
}

.language-dropdown .ant-dropdown-menu {
  min-width: 240px !important;
  width: 100% !important;
}

.language-dropdown .ant-dropdown-menu-item {
  width: 100% !important;
  padding: ${LAYOUT.mobile.paddingVertical} ${LAYOUT.mobile.paddingHorizontal};
  display: flex;
  align-items: center;
}



  a {
    color: var(--primary-text-color);
    &:hover,:active {
      color: var(--ant-primary-color-hover);
    }
  }
  
  .d-none {
    display: none;
  }

  .ant-picker-cell {
    color: var(--text-main-color);
  }

  .ant-picker-cell-in-view .ant-picker-calendar-date-value {
    color: var(--text-main-color);
    font-weight: ${FONT_WEIGHT.bold};
  }

  .ant-picker svg {
    color: var(--text-light-color);
  }

  // notifications start
  .ant-notification-notice {
    width: min(36rem, calc(100vw - 2rem));
    max-width: calc(100vw - 1rem);
    padding: 2rem;
    min-height: 6rem;
    box-sizing: border-box;
    overflow-wrap: anywhere;
    
    .ant-notification-notice-with-icon .ant-notification-notice-message {
      margin-bottom: 0;
      margin-left: 2.8125rem;
      padding-right: 1.5rem;
    }

    .ant-notification-notice-with-icon .ant-notification-notice-description {
      margin-left: 4.375rem;
      margin-top: 0;
      padding-right: 0.75rem;
    }

    .ant-notification-notice-icon {
      font-size: 2.8125rem;
      margin-left: 0
    }

    .ant-notification-notice-close {
      top: 1.25rem;
      right: 1.25rem;
    }

    .ant-notification-notice-close-x {
      display: flex;
      font-size: 0.9375rem;
    }

    &.notification-without-description {
      .ant-notification-notice-close {
        top: 1.875rem;
      }
      .ant-notification-notice-with-icon .ant-notification-notice-description  {
        margin-top: 0.625rem;
      }
    }
    
    .title {
      font-size: ${FONT_SIZE.xxl};
      min-height: 3rem;
      margin-left: 1.5rem;
      display: flex;
      align-items: center;
      font-weight: ${FONT_WEIGHT.bold};
      line-height: 1.35;

      &.title-only {
        color: var(--text-main-color);
        font-size: ${FONT_SIZE.md};
        min-height: 2rem;
        line-height: 2rem;
        margin-left: 0.75rem;
        font-weight: ${FONT_WEIGHT.semibold};
      }
  }
  
    .description {
      color: var(--text-main-color);
      font-size: ${FONT_SIZE.md};
      font-weight: ${FONT_WEIGHT.semibold};
      line-height: 1.375rem;
      overflow-wrap: anywhere;
    }
  
    &.ant-notification-notice-success {
      border: 1px solid var(--success-color);
      background: var(--notification-success-color);
      
      .title {
        color: var(--success-color);
      }
    }
  
    &.ant-notification-notice-info {
      border: 1px solid var(--primary-color);
      background: var(--notification-primary-color);
  
      .title {
        color: var(--primary-text-color);
      }
    }
  
    &.ant-notification-notice-warning {
      border: 1px solid var(--warning-color);
      background: var(--notification-warning-color);
  
      .title {
        color: var(--warning-color);
      }
    }
  
    &.ant-notification-notice-error {
      border: 1px solid var(--error-color);
      background: var(--notification-error-color);
  
      .title {
        color: var(--error-color);
      }
    }
  
    .success-icon {
      color: var(--success-color);
    }
  
    .info-icon {
      color: var(--primary-text-color);
    }
  
    .warning-icon {
      color: var(--warning-color);
    }
  
    .error-icon {
      color: var(--error-color);
    }

    @media only screen and ${media.md} and (max-width: ${
  BREAKPOINTS.xl - 0.02
}px) {
      width: min(30rem, calc(100vw - 2rem));
      padding: 1.5rem;
      min-height: 5rem;

      .ant-notification-notice-with-icon .ant-notification-notice-message {
        margin-left: 2.125rem;
      }

      .ant-notification-notice-with-icon .ant-notification-notice-description {
        margin-left: 3.375rem;
      }

      .ant-notification-notice-icon {
        font-size: 2.25rem;
      }

      .ant-notification-notice-close {
        top: 1rem;
        right: 1rem;
      }

      .title {
        font-size: ${FONT_SIZE.xl};
        min-height: 2.5rem;
        margin-left: 1rem;
      }
    }

    @media only screen and (max-width: ${BREAKPOINTS.md - 0.02}px) {
      width: calc(100vw - 1rem);
      max-width: calc(100vw - 1rem);
      padding: 1rem;
      min-height: auto;

      .ant-notification-notice-with-icon .ant-notification-notice-message {
        margin-left: 3.5rem;
        min-height: 1.5rem;
        padding-right: 1.5rem;
      }

      .ant-notification-notice-with-icon .ant-notification-notice-description {
        margin-left: 3.5rem;
        padding-right: 0.5rem;
      }

      .ant-notification-notice-icon {
        font-size: 1.5rem;
        line-height: 1.5rem;
      }

      .ant-notification-notice-close {
        top: 0.75rem;
        right: 0.75rem;
      }

      &.notification-without-description {
        .ant-notification-notice-close {
          top: 1rem;
        }
      }

      .title {
        font-size: ${FONT_SIZE.md};
        min-height: unset;
        margin-left: 0;
        padding-right: 1rem;

        &.title-only {
          min-height: unset;
          line-height: 1.5rem;
          margin-left: 0;
          padding-right: 1rem;
        }
      }

      .description {
        font-size: ${FONT_SIZE.xs};
        line-height: 1.25rem;
      }
    }
  }
  
  .ant-menu-inline, .ant-menu-vertical {
    border-right: 0;
  }

  .ant-table-tbody > tr > td {
    border-bottom-color: transparent !important;
  }

  .ant-table.ant-table-bordered .ant-table-tbody > tr > td {
    border-inline-end-color: transparent !important;
  }
  /* notifications end */

  /* Bordered descriptions follow the table header tokens of the active theme
     (antd keeps a fixed light label background, unreadable in the dark theme).
     The body prefix beats antd's default and stays below the CNH theme rules. */
  body .ant-descriptions-bordered .ant-descriptions-item-label {
    background-color: var(--table-header-background-color);
    color: var(--text-main-color);
  }

  body .ant-descriptions-bordered .ant-descriptions-view,
  body .ant-descriptions-bordered .ant-descriptions-row,
  body .ant-descriptions-bordered .ant-descriptions-item-label,
  body .ant-descriptions-bordered .ant-descriptions-item-content {
    border-color: var(--table-border-color);
  }

`;
